import script from "./IconAttachmentFile.vue?vue&type=script&setup=true&lang=ts"
export * from "./IconAttachmentFile.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__